import { CSRadioListOption } from "components/shared/form/cs-form-input/CSRadioList";
import { QuestionRoleType } from "consts";
import React from "react";

const QuestionTypeOption = (props: { title: string; description: string }) => (
  <>
    <span className="fw-bold me-2">{props.title}</span>
    <span className="fw-normal">{props.description}</span>
  </>
);

/**
 * Options for the question type radio list.
 */
export const questionTypeOptions: CSRadioListOption[] = [
  {
    label: (
      <QuestionTypeOption
        title="Engagement"
        description="questions capture the attention of your audience and encourage participation."
      />
    ),
    value: QuestionRoleType.Engagement,
  },
  {
    label: (
      <QuestionTypeOption title="Value" description="questions gather meaningful information from your audience." />
    ),
    value: QuestionRoleType.Value,
  },
  {
    label: <QuestionTypeOption title="Profile" description="questions build a demographic profile of your audience." />,
    value: QuestionRoleType.Profile,
  },
];
